import * as S from './Hero.style';

export const Brand = ({
  active,
  brand,
}: {
  active: string;
  brand: {
    image: {
      url: string;
    };
  };
}) => {
  return (
    <S.Image>
      <img
        src={brand.image.url}
        className={active ? 'active' : 'disable'}
        width={500}
        height={500}
      />
    </S.Image>
  );
};
